module.exports = __webpack_public_path__ + "static/img/h_2_36.0bfa686.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/h_2_36.png
// module id = nnWq
// module chunks = 0